// The server's `TABULAR_EXTENSIONS` (spectre.core.tabular). Structured mapping is the
// default; an explicit saved choice can send the whole table through AI extraction.

const TABLE_FILE_TYPES: ReadonlySet<string> = new Set(['csv', 'tsv', 'xls', 'xlsx', 'xlsm'])

/** A delimited text table or a spreadsheet, by the document's file type or extension. */
export function isTableFileType(fileType: string | null | undefined): boolean {
  return TABLE_FILE_TYPES.has(fileType?.toLowerCase() ?? '')
}
